import React from 'react';
import { EntityAboutCard } from '@backstage/plugin-catalog';
import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';
import { useIsGuest } from '../guest';
import { GuestAboutContent } from './GuestAboutContent';

export const GuestAwareAboutCard = () => {
  const isGuest = useIsGuest();
  const { entity } = useEntity();

  if (!isGuest) {
    return <EntityAboutCard />;
  }

  return (
    <EntityInfoCard title="About">
      <GuestAboutContent entity={entity} />
    </EntityInfoCard>
  );
};
